import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const validationSchema = (t: TFunction) =>
  Yup.object().shape({
    point: Yup.number()
      .required(t('Please enter points'))
      .positive(t('Points must be greater than zero')),
    comments: Yup.string().required(t('Please enter comments')),
  });

export type AdjustPointsValidationSchemaType = ReturnType<
  typeof validationSchema
>;
